/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SingleCellIndicator = {
  coordinates: string;
  y_value: string;
  x_value: string;
  direction: SingleCellIndicator.direction;
};
export namespace SingleCellIndicator {
  export enum direction {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
  }
}
